import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// 引入echarts
import echarts from 'echarts'
// elementUi
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// http
import HttpRequest from './libs/http.js'
// 公用方法
import utils from './libs/utils.js'
// 公用组件
import component from './components/index'
// 图标文件
import '@/assets/iconFont/iconfont.css'
// 主要样式
import '@/assets/styles/main.scss'
// 自定义主题颜色
import '@/assets/styles/theme.scss'
import "@/assets/fonts/font.css"
// 权限
import Permission from './libs/permission.js'
import Api from './libs/api'
import htmlToPdf from '@/utils/htmlToPdf'
// import Vueload from 'vue-load'
import { CountDown } from 'vant'
//国际化
import i18n from './i18n'
Vue.use(ElementUI, {
    i18n: (key, value) => i18n.t(key, value),
    size: 'small',
})

Vue.use(CountDown)
// Vue.use(Vueload.components.YsLoad1)
Vue.use(utils)
Vue.use(component)
Vue.use(ElementUI)
Vue.use(require('vue-moment'))
Vue.use(htmlToPdf)
Vue.prototype.$echarts = echarts
Vue.prototype.$http = new HttpRequest()
Vue.prototype.$permission = Permission
Vue.prototype.$api = Api
Vue.config.productionTip = false
console.logrouter
new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app')
